import React from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import {
  SUBSCRIPTION_TAG,
  subscriptionApi,
  TCompanyInfo,
} from '@/features/subscription/apiSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { closeReactModal, openReactModal } from '@/actions';
import CompanyDetailsModal from '@/components/billing/CompanyDetailsModal';
import { useAppDispatch } from '@/store/hooks';
import { Tooltip } from '@trevor/ui-components';
import styled from 'styled-components';

const tooltipEnterInfo = 'tooltip-enter-info';

const TooltipEnterInfo = styled(Tooltip).attrs({ place: 'right' })`
  z-index: auto;
`;

export const CompanyAddress: React.FC<{
  companyInfo: TCompanyInfo;
  updateCompanyInfo: F<TCompanyInfo>;
  showWarning: boolean;
}> = ({ companyInfo, updateCompanyInfo, showWarning }) => {
  const dispatch = useAppDispatch();

  const completedCompanyFields = () =>
    Object.values(companyInfo).filter(Boolean);

  const onOpenCompanyDetailsModal = () => {
    const closeModal = (isUpdated: boolean) => (_companyInfo: TCompanyInfo) => {
      dispatch(closeReactModal());
      if (isUpdated) {
        updateCompanyInfo(_companyInfo);
        dispatch(subscriptionApi.util.invalidateTags([SUBSCRIPTION_TAG]));
      }
    };
    dispatch(
      openReactModal(
        <CompanyDetailsModal
          closeModal={closeModal(false)}
          onUpdated={closeModal(true)}
          companyInfo={companyInfo}
        />,
      ),
    );
  };

  const displayCompanyInfo = () => {
    const details = completedCompanyFields();
    return details.map((item, i) => (
      <span key={i} style={{ whiteSpace: 'nowrap' }}>
        {item}
        {i === details.length - 1 ? null : <span>,&nbsp;</span>}
      </span>
    ));
  };

  const hasAddress = completedCompanyFields().length > 0;

  return (
    <div className={css.section}>
      <div className={`${flex.row} ${flex.alignItemsStart}`}>
        <div className={css.billingIcon}>
          <FontAwesomeIcon icon="home" />
        </div>
        <div>
          <div className={flex.row}>
            {hasAddress ? (
              <span className={`${flex.row} ${flex.wrap}`}>
                <b>Company info:</b>&nbsp;
                {displayCompanyInfo()}&nbsp;&nbsp;
                <span onClick={onOpenCompanyDetailsModal} className="link">
                  Edit
                </span>
              </span>
            ) : (
              <span onClick={onOpenCompanyDetailsModal} className="link">
                <b data-tooltip-id={tooltipEnterInfo}>Add company info</b>
                <TooltipEnterInfo id={tooltipEnterInfo} isOpen={showWarning}>
                  Please enter company information to continue
                </TooltipEnterInfo>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
